import React from 'react';

interface VerifiedBadgeProps {
  size?: number;
  style?: React.CSSProperties;
}

const VerifiedBadge: React.FC<VerifiedBadgeProps> = ({ size = 16, style }) => {
  return (
    <span
      title="Verified Account"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        backgroundColor: '#1DA1F2',
        borderRadius: '50%',
        color: '#FFFFFF',
        fontSize: size * 0.7,
        fontWeight: 'bold',
        marginLeft: 4,
        ...style,
      }}
    >
      ✓
    </span>
  );
};

export default VerifiedBadge;
